// extracted by mini-css-extract-plugin
module.exports = {"AuthContainer":"authLayout_AuthContainer__xqh_3"};